module.exports = __webpack_public_path__ + "static/img/userhead.d56b7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userhead.png
// module id = MluR
// module chunks = 31